exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".-large{padding:1rem;max-width:800px}.form-btn{margin-top:0.3rem}\n", ""]);

